import { COMPONENT_TYPES } from '../../../constants';
import MainBannerComponent from './MainBanner.component';
import MainBannerEditor from './MainBanner.editor';
import MainBannerProperties from './MainBanner.properties';
import { adaptMainBannerProps, adaptMainBannerEditorProps } from './MainBanner.adapter';
import type { MainBannerProps, MainBannerEditorProps, BannerItem } from './MainBanner.types';
import { registerComponent } from '../registry';

// 컴포넌트 타입 상수
export const COMPONENT_TYPE = 'MainBanner';

// 기본 속성 정의
export const defaultProps: MainBannerProps = {
  mode: 'slider',
  banners: [
    {
      text: '환영합니다!',
      description: '메인 배너에 오신 것을 환영합니다.',
      url: '#',
      icon: 'https://via.placeholder.com/1600x700',
      mediaType: 'image',
      position: '5',
      textColor: 'white',
      textShadow: '0 1px 2px rgba(0, 0, 0, 0.6)',
      buttonBgColor: '#ff6b6b',
      buttonTextColor: 'white',
      buttonHoverColor: '#ff5252',
      buttonText: '자세히 보기',
      showTitle: true,
      showButton: true,
      transparentButton: false,
      hasBackground: false,
      mobileFullWidth: false
    }
  ],
  style: {
    width: '100%',
    height: 'auto'
  },
  content: {
    banners: []
  }
};

// 레지스트리에 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.MAIN_BANNER,
  component: MainBannerComponent,
  editorComponent: MainBannerEditor,
  properties: MainBannerProperties,
  defaultProps,
  category: 'content', // 컴포넌트 카테고리
  icon: '🖼️', // 대표 아이콘
  name: '메인 배너' // 표시할 이름
});

// 컴포넌트 및 관련 항목 내보내기
export {
  MainBannerComponent,
  MainBannerEditor,
  MainBannerProperties,
  adaptMainBannerProps,
  adaptMainBannerEditorProps
};

// 타입 내보내기
export type {
  MainBannerProps,
  MainBannerEditorProps,
  BannerItem
};

// 기본 내보내기는 MainBanner 컴포넌트
export default MainBannerComponent; 